import * as React from "react";
import classNames from "classnames";

export type TIconNames =
    | "24_expand"
    | "24_play"
    | "24_star"
    | "24_trash"
    | "32_add-user"
    | "32_basket"
    | "32_checkmark-circle"
    | "32_checkmark"
    | "32_error"
    | "32_information"
    | "32_katalog"
    | "32_search"
    | "32_truck-in-motion"
    | "32_user"
    | "32_warning"
    | "icon_16_arrow-down"
    | "icon_16_arrow-left"
    | "icon_16_arrow-right-bold"
    | "icon_16_arrow-right"
    | "icon_16_arrow-up"
    | "icon_28_close"
    | "icon_32_thumbs-up"
    | "icon_80x41_quotation-mark-gyldendal-dk"
    | "icon_80x48_quotation-mark"
    | "icon_checkbox-black"
    | "icon_checkmark-black"
    | "icon_download"
    | "icon_herringbone-narrow"
    | "icon_herringbone-wide"
    | "icon_placeholder-email"
    | "icon_placeholder-lock"
    | "icon_placeholder-phone-small"
    | "icon_placeholder-vip-white"
    | "icon_placeholder_basket"
    | "icon_placeholder_checkmark"
    | "icon_placeholder_eye-closed"
    | "icon_placeholder_eye"
    | "icon_placeholder_facebook"
    | "icon_placeholder_filtering"
    | "icon_placeholder_hamburger"
    | "icon_placeholder_instagram"
    | "icon_placeholder_phone"
    | "icon_placeholder_user"
    | "icon_read"
    | "icon_listen";

export interface IIconProps {
    iconId: TIconNames;
    spriteUrl?: string;
    viewBox?: string;
    className?: string;
    onClick?: () => void;
}

const Icon: React.FC<IIconProps> = props => {
    const spriteUrl = props.spriteUrl || "";
    const viewBox = props.viewBox || "0 0 32 32";

    return (
        <svg
            viewBox={viewBox}
            className={classNames(props.className, "icon", `icon-${props.iconId}`)}
            preserveAspectRatio="xMidYMid"
            onClick={() => props.onClick && props.onClick()}
        >
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`${spriteUrl}#${props.iconId}`} />
        </svg>
    );
};

export default Icon;
